export const PERSONAL_INITIAL = {
  nombres: "",
  apellidos: "",
  email: "",
  celular: "",
  municipio: "No aplica",
  comuna: "No aplica",
  barrio: "No aplica",
  password: "",
  acepta_politica_datos: false,
  comparte_contacto: false,
};

export const INITIATIVE_INITIAL = {
  nombre: "",
  tipo_iniciativa: "HUERTA",
  tipo_acceso: "ABIERTO",
  descripcion: "",
  direccion: "",
  latitud: 6.2442,
  longitud: -75.5812,
  pais: "Colombia",
  region: "Antioquia",
  ciudad: "Medellin",
  municipio: "Medellin",
  comuna: "",
  barrio: "",
  nombre_contacto: "",
  celular_contacto: "",
  email_contacto: "",
  sitio_web: "",
  instagram_url: "",
  facebook_url: "",
  whatsapp_url: "",
  publicar_nombre_contacto: true,
  publicar_celular_contacto: false,
  publicar_email_contacto: false,
  publicar_direccion: true,
  publicar_horarios: true,
  publicar_whatsapp: false,
  publicar_enfoque_poblacional: false,
  horarios_encuentro: "",
  ano_inicio: "",
  enfoque_poblacional: [],
};

export const PUBLICATION_INITIAL = {
  titulo: "",
  tipo_oferta: "PRODUCTO_AGROECOLOGICO",
  descripcion: "",
  direccion: "",
  latitud: 6.2442,
  longitud: -75.5812,
  municipio: "Medellin",
  comuna: "",
  barrio: "",
  initiative_id: null,
  nombre_iniciativa: "",
  nombre_contacto: "",
  celular_contacto: "",
  email_contacto: "",
  sitio_web: "",
  instagram_url: "",
  facebook_url: "",
  whatsapp_url: "",
  publicar_nombre_contacto: true,
  publicar_celular_contacto: false,
  publicar_email_contacto: false,
  publicar_direccion: true,
  publicar_whatsapp: false,
  enfoques_asociados: [],
  acepta_deslinde_responsabilidad: false,
};

export const STEP_META = [
  { id: 1, label: "Datos personales" },
  { id: 2, label: "Mapa" },
  { id: 3, label: "Directorio" },
  { id: 4, label: "Revisión" },
];

export const MAP_PARTICIPATION_OPTIONS = [
  {
    value: "existing",
    label: "Sí, ya está en Polénica",
    description: "Si la huerta o paca ya existe en la red, puede vincularla a su perfil.",
  },
  {
    value: "new",
    label: "Sí, quiero sumarla al mapa",
    description: "Registre la información de la iniciativa para que otras personas puedan encontrarla.",
  },
  {
    value: "none",
    label: "No, todavía no hago parte",
    description: "",
  },
];

export const DIRECTORY_PARTICIPATION_OPTIONS = [
  {
    value: "share",
    label: "Sí, quiero compartir mi oferta",
    description: "Publique productos o servicios relacionados con huertas y agroecología.",
  },
  {
    value: "skip",
    label: "No por ahora",
    description: "Puede completar su cuenta y dejar esta publicación para después.",
  },
];

export const PUBLICATION_TYPE_BY_OFFER = {
  PRODUCTO_AGROECOLOGICO: "PRODUCTO",
  ALIMENTO_TRANSFORMADO: "RESTAURANTE",
  INSUMO: "SEMILLA",
  SERVICIO_TECNICO_FORMATIVO: "TIENDA_NEGOCIO",
  ARTE_CULTURA_EDUCACION: "OTRO",
  OTRO: "OTRO",
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[0-9+\s()-]{7,20}$/;
const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

export function hasText(value, minLength = 1) {
  return String(value || "").trim().length >= minLength;
}

export function isValidEmail(value) {
  return EMAIL_PATTERN.test(String(value || "").trim());
}

export function isValidPhone(value) {
  return PHONE_PATTERN.test(String(value || "").trim());
}

export function isValidPassword(value) {
  return PASSWORD_PATTERN.test(String(value || "").trim());
}

export function inputClass(hasError) {
  return `h-12 w-full rounded-2xl border px-4 outline-none transition ${
    hasError
      ? "border-[#D68B72] bg-[#FFF6F2] focus:border-[#C86A49]"
      : "border-border bg-white focus:border-primary/40"
  }`;
}

export function textareaClass(hasError) {
  return `w-full rounded-2xl border px-4 py-3 outline-none transition ${
    hasError
      ? "border-[#D68B72] bg-[#FFF6F2] focus:border-[#C86A49]"
      : "border-border bg-white focus:border-primary/40"
  }`;
}

export function joinLocation(parts) {
  return parts.filter(Boolean).join(" / ");
}
